import styled, { keyframes, css } from "styled-components";
import { viewSizeCalculator } from "../../utils";

// Define the Center variable
const Center = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
`;

export const Container = styled.div`
  width: ${() => viewSizeCalculator(26.625)};
  height: ${() => viewSizeCalculator(15.375)};
  border-radius: ${() => viewSizeCalculator(1.25)};

  position: fixed;
  top: 50%;
  left: 50%;

  ${Center};

  transform: translate(-50%, -50%);
  z-index: 1000; /* Above the BackgroundOverlay */
  animation: ${({ showResetModal }) => (showResetModal ? fadeIn : fadeOut)} 0.3s
    ease-in-out;

  background-color: #ffffff;
  box-shadow: ${() =>
    `0 ${viewSizeCalculator(0.5)} ${viewSizeCalculator(1.5)} 0 #1616130d`};
`;

export const ContentWrapper = styled.div`
  width: ${() => viewSizeCalculator(20.625)};
  // height: ${() => viewSizeCalculator(12.125)};
  position: relative;
`;

export const CrossIconWrapper = styled.div`
  width: ${() => viewSizeCalculator(1.75)};
  height: ${() => viewSizeCalculator(1.75)};

  ${Center};

  position: absolute;
  right: ${() => viewSizeCalculator(-1.9813)};
  top: ${() => viewSizeCalculator(-0.8813)};

  svg {
    cursor: pointer;
    width: ${() => viewSizeCalculator(1.5)};
    height: ${() => viewSizeCalculator(1.5)};
  }
`;

export const WarningIconWrapper = styled.div`
  width: 100%;
  ${Center};
  padding-bottom: ${() => viewSizeCalculator(0.75)};

  svg {
    width: ${() => viewSizeCalculator(3)};
    height: ${() => viewSizeCalculator(3)};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => viewSizeCalculator(0.25)};
`;

export const Title = styled.h1`
  font-family: Inter;
  font-weight: 700;
  font-size: ${() => viewSizeCalculator(1)};
  line-height: ${() => viewSizeCalculator(1.5)};
  letter-spacing: -2.2%;
  text-align: center;
  color: #000000;
`;

export const SubTitle = styled.h3`
  font-family: Inter;
  font-weight: 400;
  font-size: ${() => viewSizeCalculator(0.875)};
  line-height: ${() => viewSizeCalculator(1.3125)};
  letter-spacing: -2.2%;
  text-align: center;
  color: #333333;
  opacity: 0.6;
  white-space: pre-line;
`;

export const ButtonWrapper = styled.div`
  ${Center};
  gap: ${() => viewSizeCalculator(0.625)};
  padding-top: ${() => viewSizeCalculator(1.0625)};
`;

export const Button = styled.button`
  width: ${() => viewSizeCalculator(6.5)};
  height: ${() => viewSizeCalculator(2.5)};
  padding: ${() =>
    `${viewSizeCalculator(0.3125)} ${viewSizeCalculator(
      1,
    )} ${viewSizeCalculator(0.3125)} ${viewSizeCalculator(1)}`};
  border: ${({ borderColor }) =>
    `${viewSizeCalculator(0.0625)} solid ${borderColor}`};
  border-radius: ${() => viewSizeCalculator(1.25)};
  background-color: ${({ backgroundColor }) => backgroundColor};

  font-family: Inter;
  font-weight: 600;
  font-size: ${() => viewSizeCalculator(0.875)};
  line-height: ${() => viewSizeCalculator(1.3125)};
  letter-spacing: -2.2%;
  color: ${({ color }) => color};
  cursor: pointer;
`;
